import { render } from "./BaseGenericOffcanvas.vue?vue&type=template&id=d6b6cb74&scoped=true"
import script from "./BaseGenericOffcanvas.vue?vue&type=script&lang=js"
export * from "./BaseGenericOffcanvas.vue?vue&type=script&lang=js"

import "./BaseGenericOffcanvas.vue?vue&type=style&index=0&id=d6b6cb74&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6b6cb74"]])

export default __exports__